import {
    createRegisterableComponentWithData,
    SubscriptionOfferLoader,
} from '@news-mono/web-common'
import { OfferVariantType } from '@west-australian-newspapers/subscription-offer-types'
import React from 'react'
import { BreachWallContentWrapper } from './components/BreachWallContentWrapper/BreachWallContentWrapper'

export type BreachScreenRegistrationProps = {
    breachwall?: 'default'
    breachDeal?: string
    /** Breach wall style and package to use from the offers API. Defaults to active feature toggle unless provided. */
    breachType?: OfferVariantType
    title?: string
    bannerMessage?: string
    message?: string
    terms?: string
    renditionType?: string
    enableSwgCampaign?: boolean
    breachCreativeName?: string
}

export const BreachScreenRegistration = createRegisterableComponentWithData(
    'breachscreen',
    SubscriptionOfferLoader,
    (props: BreachScreenRegistrationProps, data, services) => {
        return (
            <BreachWallContentWrapper
                {...props}
                requiredAccess={'subscriber'}
                location={services.location}
                onEvent={services.onEvent}
                log={services.log}
                initialOfferData={data.loaded ? data.result : undefined}
            />
        )
    },
)
